<template>
    <div class="articleManager">
        <HandMenu/>
        <el-card shadow="never" style="border: 0;border-right: 1px solid #EBEEF5;">
            <el-row :gutter="20">
                <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                </el-breadcrumb>
                <div v-loading="loading">
                    <el-col style="margin-bottom: 10px" :xs="24" :sm="12" :md="8" :lg="5" :xl="4">
                        <el-input placeholder="输入标题搜索" v-model="articleContentTitle"
                                  class="input-with-select">
                        </el-input>
                    </el-col>
                    <el-col style="margin-bottom: 10px" :xs="24" :sm="12" :md="8" :lg="5" :xl="4">
                        <div class="block">
                            <el-date-picker
                                    style="width: 100%;"
                                    v-model="time"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerOptions">
                            </el-date-picker>
                        </div>
                    </el-col>

                    <el-col style="margin-bottom: 10px" :xs="24" :sm="24" :md="24" :lg="9" :xl="12">
                        <el-button type="primary" @click="selectArticleTable"  plain>搜索</el-button>
                        <el-button type="success" @click="clearSelect" plain>清空</el-button>
                        <el-button type="info" @click="refreshTable"  plain>刷新</el-button>
                    </el-col>
                    <el-table
                            :data="tableData"
                            border
                            :header-cell-style="cellStyle"
                            :cell-style="cellStyle"
                            style="width: 100%">
                        <el-table-column
                                fixed
                                type="index"
                                label="#"
                                width="50"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="articleInf.articleTitle"
                                label="活动标题"
                        >
                        </el-table-column>
                        <el-table-column
                                label="活动封面"
                        >
                            <template slot-scope="scope">
                                <el-image
                                        style="width: 50px; height: 50px"
                                        :src="scope.row.articleInf.articleImg"
                                        :preview-src-list="[scope.row.articleInf.articleImg]">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="articleInf.articleCtime"
                                label="发布时间"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="articleInf.articleActivityTime"
                                label="活动时间"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="userInf.userName"
                                label="创建人"
                        >
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="150">
                            <template slot-scope="scope">
                                <el-button slot="reference" @click="$router.push({name:'changeArticle',query: {id:scope.row.articleInf.articleId}})" type="text" size="small">修改</el-button>

                                <!--删除内容的按钮-->
                                <el-popconfirm
                                        style="margin-left: 10px;"
                                        icon="el-icon-info"
                                        iconColor="red"
                                        title="是否确认删除内容？删除后无法恢复！"
                                        @onConfirm="deleteArticle(scope.row)"
                                >
                                    <el-button slot="reference" type="text" size="small">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页器-->
                    <div class="block" style="margin-top: 10px;text-align: right">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[5, 10, 20, 30]"
                                :page-size="10"
                                layout="prev, pager, next, jumper,sizes"
                                :total="articleContentTotal">
                        </el-pagination>
                    </div>
                </div>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    import axios from "../../api/index"
    import Vue from "../../main";

    export default {
        name: "ArtileManager",
        data() {
            return {
                //表格内容
                tableData:[],
                //loading
                loading: true,
                //搜索标题
                articleContentTitle:"",
                //分页器 当前页数
                currentPage: 1,
                //分页器 每页显示几条
                pageSize: 10,
                //总共有多少条数据
                articleContentTotal: 0,
                //日期选择器
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                //日期选择器
                time: [],
            }
        },
        methods: {
            //清除搜索框
            clearSelect() {
                this.articleContentTitle = "";
                this.time = [];
            },
            //分页器 当前每页几条
            handleSizeChange(val) {
                this.loading = true;
                this.pageSize = val;
                this.getTableData();
            },
            //分页器当前在第几页
            handleCurrentChange(val) {
                this.loading = true;
                this.currentPage = val;
                this.getTableData();
            },
            cellStyle({columnIndex}) {
                //让序号那一列居中
                if (columnIndex === 0) {
                    // 指定列号
                    return 'text-align: center;'
                } else {
                    return ''
                }
            },
            //获取表格内容
            getTableData() {
                let self = this;
                axios.getArticleContentManager({
                    //当前页
                    page: self.currentPage,
                    //搜索标题
                    title: self.articleContentTitle,
                    //时间搜索
                    beginTime: self.time[0],
                    endTime: self.time[1],
                    //每页显示几条
                    showCount: self.pageSize
                }).then(res => {
                    self.tableData = res.data.articleDtos;
                    self.loading=false;
                })
            },
            //获取总页数
            getTotal() {
                let self = this;
                axios.getArticleContentTotal({
                    //搜索标题
                    title: self.articleContentTitle,
                    //时间搜索
                    beginTime: self.time[0],
                    endTime: self.time[1],
                }).then(res => {
                    if (res.data.total != null) {
                        self.articleContentTotal = res.data.total;
                    } else {
                        self.arContentTotal = 0;
                    }
                })
            },
            //删除文章
            deleteArticle(row){
                let self =this;
                axios.deleteArticle({
                    articleId:row.articleInf.articleId
                }).then(res=>{
                    if (res.data==="success"){
                        Vue.$message({
                            message: "删除成功!",
                            duration: 2000,
                            type: "success"
                        });
                        //更新表格
                        self.loading = true;
                        self.getTotal();
                        self.currentPage = 1;
                        self.getTableData();
                    }else{
                        Vue.$message({
                            message: "删除失败！",
                            duration: 2000,
                            type: "error"
                        });
                    }
                })

            },
            //搜索
            selectArticleTable() {
                //先获取总页数
                this.getTotal();
                //设置当前页为1
                this.currentPage = 1;
                //获取内容
                this.getTableData();
            },
            //刷新表格
            refreshTable() {
                //获取内容
                this.getTableData();
            },
        },
        mounted() {
            this.getTableData();
            this.getTotal();
        }
    }
</script>

<style scoped>
    .articleManager {
        flex: 1;
        overflow: auto;
        width: 100%;
        border: 0;
    }
</style>
